module.exports = "\n<app-menu></app-menu>\n\n<router-outlet></router-outlet>\n\n<alert></alert>\n\n<impostazione-cookie></impostazione-cookie>\n"


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main